import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogComponent } from '@core/components/confirm-dialog/confirm-dialog.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogComponent, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  providers: [ConfirmationService],
})
export class App {
  title = 'Add Codi';

  constructor(private titleService: Title) {
    this.titleService.setTitle($localize`${this.title}`);
  }
}
